interface CobuLogoProps {
  /** Give either dimension; the other follows the wordmark's 280:82 aspect ratio. */
  width?: number;
  height?: number;
  fill?: string;
  /** Omit to mark the logo decorative — correct wherever "Cobu" is already in the text. */
  title?: string;
}

const ASPECT_RATIO = 280 / 82;

export default function CobuLogo({ width, height, fill = 'currentColor', title }: CobuLogoProps) {
  const resolvedHeight = height ?? (width !== undefined ? width / ASPECT_RATIO : 16);
  const resolvedWidth = width ?? resolvedHeight * ASPECT_RATIO;

  return (
    <svg
      width={resolvedWidth}
      height={resolvedHeight}
      viewBox="0 0 280 82"
      fill="none"
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
        d="M161.178 74.978c3.767 3.964 9.252 6.572 17.024 6.572 16.441 0 27.65-12.907 27.65-30.806 0-17.9-11.209-30.584-27.65-30.584a25.067 25.067 0 0 0-17.024 6.23V.068a.061.061 0 0 0-.022-.05.066.066 0 0 0-.052-.017h-19.116v80.416h19.19v-5.438Zm0-33.837a17.961 17.961 0 0 1 11.538-4.445v-.03c8.221 0 13.594 5.468 13.594 14.077 0 8.72-5.373 14.27-13.594 14.27a18.267 18.267 0 0 1-11.538-4.305V41.14ZM40.213 81.553c11.803-.15 23.143-4.583 31.872-12.462l-8.908-14.136c-5.485 4.986-13.481 9.06-22.509 9.06-12.57 0-20.79-8.038-20.79-21.966 0-14.188 8.228-22.227 20.103-22.227 9.916 0 14.28 5.89 14.4 15.18l17.592-3.63c-.456-17.988-11.658-29.101-31.76-29.101C17.247 2.27 0 16.99 0 42.026c0 24.798 17.248 39.527 40.212 39.527Zm64.836-61.957c18.735 0 32.328 13.336 32.328 31.369 0 17.781-13.593 31.035-32.328 31.035-18.51 0-32.134-13.254-32.134-31.035 0-18.011 13.593-31.37 32.134-31.37Zm-.002 45.2c8.34 0 13.825-6.23 13.825-13.817 0-7.816-5.485-14.077-13.825-14.077-8.115 0-13.593 6.224-13.593 14.077 0 7.587 5.478 13.818 13.593 13.818Zm165.014-4.658V21.182h-19.124a.067.067 0 0 0-.067.067V58.44c-2.353 3.67-6.465 5.86-10.851 5.779-7.809 0-10.051-3.741-10.051-11.558v-31.48h-19.124a.066.066 0 0 0-.052.017.067.067 0 0 0-.022.05V55.38c0 15.181 6.516 26.168 21.933 26.168 8.34 0 15.17-2.719 19.654-7.705 2.152 5.438 6.853 7.705 13.362 7.705 5.717 0 11.292-1.133 14.281-2.496l-.68-15.063a14.099 14.099 0 0 1-5.829 1.586c-2.855 0-3.43-2.475-3.43-5.438Z"
      />
    </svg>
  );
}
